export const STAGES = ["Property Sourcing & Initial Chat", "Refurbishment", "Compliance & Licensing", "Operational Setup"];

export const ROLE_LABELS = {
  admin: "Admin",
  operations: "Operations",
  compliance: "Compliance",
  landlord: "Owner",
};

export const ROLE_COLORS = {
  admin: "bg-[#18181A] text-white",
  operations: "bg-[#2B4C3F]/12 text-[#2B4C3F]",
  compliance: "bg-[#C6A87C]/20 text-[#8a6d3b]",
  landlord: "bg-[#3a4a6b]/12 text-[#3a4a6b]",
};

// which stage a property is currently working on
export function currentStage(prop) {
  if (prop.status === "live") return "Live";
  if (prop.board_stage && STAGES.includes(prop.board_stage)) return prop.board_stage;
  const items = prop.checklist || [];
  for (const st of STAGES) {
    const stageItems = items.filter((i) => i.stage === st);
    if (stageItems.some((i) => i.status !== "complete")) return st;
  }
  return "Live";
}

export function expiryBadge(status) {
  switch (status) {
    case "expired":
      return { label: "Expired", cls: "bg-[#9E382A]/12 text-[#9E382A] border-[#9E382A]/20" };
    case "expiring":
      return { label: "Expiring", cls: "bg-[#D98324]/12 text-[#D98324] border-[#D98324]/20" };
    default:
      return { label: "Valid", cls: "bg-[#2B4C3F]/12 text-[#2B4C3F] border-[#2B4C3F]/20" };
  }
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
}

export const RENTAL_LABELS = { holiday: "Holiday let", long_term: "Long-term" };

// Terminology adapts to the property's rental type (holiday vs long-term).
export function terms(rentalType) {
  const holiday = rentalType === "holiday";
  return {
    occupant: holiday ? "Guest" : "Tenant",
    occupants: holiday ? "Guests" : "Tenants",
    income: holiday ? "Booking income" : "Rent",
    tenancy: holiday ? "Stay" : "Tenancy",
    mode: holiday ? "Holiday let" : "Long-term",
  };
}
